/* @flow */

/**
 * Filters an array of Objects by a search string
 * considers each word in each value specified by keys
 *
 * @method filterSearchList
 * @param {Array<Object>} items
 * @param {String} search
 * @param {Array<String>} keys = ['name']
 * @return {Array<Object>}
 */
export const filterSearchList: Function = (
  items: Array<Object>,
  search: string,
  keys: Array<string> = ['name']
): Array<Object> => {
  const chars = /\b[,]|\s[-]/g;
  const searchTerms: Array<string> = search.replace(chars, '');

  return items.filter(
    (item: Object): boolean => {
      const keyValues: Array<string> = [];

      keys.forEach((key: string) => keyValues.push(item[key].toLowerCase()));

      return keyValues.join(' ').indexOf(searchTerms.toLowerCase()) !== -1;
    }
  );
};
